export interface ScenarioPositionSyncInput {
  isStaleOrgHostScenario: boolean;
  isScenarioActive: boolean;
  wasScenarioActive: boolean;
}

export interface ScenarioPositionSyncDecision {
  shouldSyncPositions: boolean;
  nextWasScenarioActive: boolean;
}

export function resolveScenarioPositionSyncDecision(
  input: ScenarioPositionSyncInput
): ScenarioPositionSyncDecision {
  if (input.isStaleOrgHostScenario) {
    return {
      shouldSyncPositions: false,
      nextWasScenarioActive: input.wasScenarioActive,
    };
  }

  return {
    shouldSyncPositions: input.isScenarioActive || input.wasScenarioActive,
    nextWasScenarioActive: input.isScenarioActive,
  };
}
